module.exports = __webpack_public_path__ + "bad782b30ee54444cc4ca63a7a196a21.png";